// Kaching Bundles localisation (port of the 4.0 "Kaching Injector" block): delivery line for subscriptions,
// price per day from the real price, gift values and "12,00 €" formatting per market. Texts come from locale keys (cloudless.kaching.*)
// rendered by cloudless-product-main; only the buy box is observed, not the whole page.
(() => {
  // Deal bar id → months. Clear+ subscription box (two A/B versions) and the one-time box on clear-otp.
  const MONTHS = {
    '6fd82602-3958-423a-b476-f8c04f482367': 1, 'd97a158b-ea49-4aab-b8b2-143b1ece3322': 3, Im7Q: 6,
    'b0abbdf6-80af-4d5b-beee-53dfae9694d2': 1, '06b148ea-0486-4040-815f-f71df67443b3': 3, 'dfb1d626-d9d4-45b4-9e40-3a955c1ed08a': 6,
    'b1636043-cd86-46fb-a66c-74bfbe11aee4': 1, 'ce6bf73e-1798-42b7-a0c9-042dc110ef4e': 3, '65c79761-23ea-49ca-b20a-19ac16cc740f': 6,
  };
  // Rounded GBP values for euro amounts in gift texts (4.0); other currencies use the Shopify rate, rounded up.
  const GBP = { 5: 5, 19: 17, 29: 26 };
  const GIFT_WORTH = /\((?:t\.w\.v\.?|worth|im Wert von|valeur de)\s*(?:€\s*(\d+)|(\d+)\s*€)\)/;

  const lang = (document.documentElement.lang || 'nl').split('-')[0].toLowerCase();
  const currency = window.Shopify?.currency?.active || 'EUR';
  const rate = Number(window.Shopify?.currency?.rate) || 1;
  const euroMarket = currency === 'EUR' && lang !== 'nl' && lang !== 'en';
  // Euro markets keep the local euro notation (1,19 € / €1,19); other currencies follow Shopify's format (2,50 zł, £1.12).
  const money = (amount, whole = false) => (currency !== 'EUR' && window.CloudlessMoney
    ? window.CloudlessMoney.format(Math.round(amount * 100), whole)
    : euroMoney(amount, whole));
  const euroMoney = (amount, whole = false) => new Intl.NumberFormat(document.documentElement.lang || 'nl', {
    style: 'currency', currency, ...(whole ? { minimumFractionDigits: 0, maximumFractionDigits: 0 } : {}),
  }).format(amount).replace(/^(€)\s/, '$1'); // €35,60 like the shop's own prices (Intl nl gives "€ 35,60")
  const fromEuro = (euros) => (currency === 'EUR' ? euros : currency === 'GBP' && GBP[euros] ? GBP[euros] : Math.ceil(euros * rate));
  const setText = (element, text) => { if (element && element.textContent !== text) element.textContent = text; };

  function readTexts(root) {
    try {
      return JSON.parse(root.querySelector('[data-cl-kaching-texts]')?.textContent || '{}');
    } catch (error) {
      console.error('Kaching texts could not be read', error);
      return {};
    }
  }

  function amountOf(text) {
    const digits = (text || '').replace(/[^\d.,]/g, '').replace(/[.,](?=\d{3}\b)/g, '');
    return Number(digits.replace(',', '.')) || 0;
  }

  function localiseBars(block, texts) {
    block.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id]').forEach((bar) => {
      const id = bar.dataset.dealBarId;
      const price = bar.querySelector('.kaching-bundles__bar-price');
      const subtitle = bar.querySelector('.kaching-bundles__bar-subtitle');
      if (euroMarket) {
        bar.querySelectorAll('.kaching-bundles__bar-price, .kaching-bundles__bar-full-price, .kaching-bundles__free-gift__full-price')
          .forEach((element) => {
            if (element.textContent.trim().startsWith('€')) setText(element, element.textContent.replace(/€\s*([\d.,]+)/, '$1 €'));
          });
      }
      if (!subtitle || !texts.per_day || !price) return;
      // Price per day from the real price in the shop currency (incl. subscription discount), 30 days per pouch.
      // Unknown deals (e.g. Glow+) use the number in their title ("3 months", "6 Beutel").
      const months = MONTHS[id] || Number(bar.querySelector('.kaching-bundles__bar-title')?.textContent.match(/\d+/)?.[0]);
      const total = amountOf(price.textContent);
      if (total && months) setText(subtitle, texts.per_day.replace('[price]', money(total / (months * 30))));
    });
  }

  function localiseGifts(block, texts) {
    if (lang === 'nl' && currency === 'EUR') return;
    block.querySelectorAll('.kaching-bundles__free-gift__text').forEach((element) => {
      const match = element.textContent.match(GIFT_WORTH);
      if (match && texts.gift_worth) {
        const worth = texts.gift_worth.replace('[price]', money(fromEuro(Number(match[1] || match[2])), true));
        setText(element, element.textContent.replace(match[0], worth));
      }
    });
    if (currency === 'EUR') return;
    block.querySelectorAll('.kaching-bundles__free-gift__full-price').forEach((element) => {
      const euros = element.textContent.includes('€') ? Math.round(amountOf(element.textContent)) : 0;
      if (euros) setText(element, money(fromEuro(euros)));
    });
  }

  function showDelivery(block, texts) {
    const checkbox = block.querySelector('.kaching-bundles__subscriptions [role="checkbox"]');
    const subscribed = checkbox?.getAttribute('aria-checked') === 'true';
    // Known Clear+ bars by id; other deals (Glow+: 1 pouch = 1 month) use the number in the bar title ("2 Zakken").
    const selected = block.querySelector('.kaching-bundles__bar--selected');
    const months = MONTHS[selected?.dataset.dealBarId] || Number(selected?.querySelector('.kaching-bundles__bar-title')?.textContent.match(/\d+/)?.[0]);
    const text = subscribed && months ? texts[`delivery_${months}`] : '';
    let item = block.querySelector('#kaching-delivery-item');
    if (!text) {
      if (item) item.style.display = 'none';
      return;
    }
    if (!item) {
      const highlights = block.querySelector('.kaching-bundles__highlights');
      const firstLine = block.querySelector('.kaching-bundles__subscriptions__card .kaching-bundles__bar-first-line');
      if (!highlights && !firstLine) return;
      item = document.createElement('div');
      item.id = 'kaching-delivery-item';
      if (highlights) {
        item.className = 'kaching-bundles__highlights__item';
        item.innerHTML = '<span class="kaching-bundles__highlights__icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M13.33 4 6 11.33 2.66 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span class="kaching-bundles__highlights__text"></span>';
        highlights.prepend(item);
      } else {
        item.innerHTML = '<span></span>';
        item.style.cssText = 'font-size:13px;color:var(--kaching-subscriptions-subtitle-color, #505c6e);margin-top:4px;';
        firstLine.after(item);
      }
    }
    setText(item.lastElementChild, text);
    item.style.display = '';
  }

  function init(root) {
    if (root.dataset.clKachingInjector === 'true') return;
    root.dataset.clKachingInjector = 'true';
    const texts = readTexts(root);
    // Runs in the observer callback (a microtask, before paint): no flash of Kaching's own text, and it also works
    // in background tabs. setText only writes changes, so our own writes settle after one extra pass.
    const run = () => {
      // The subscription card renders next to .kaching-bundles__block, so work on the whole widget.
      const block = root.querySelector('kaching-bundles-block') || root.querySelector('.kaching-bundles__block')?.parentElement;
      if (!block) return;
      localiseBars(block, texts);
      localiseGifts(block, texts);
      showDelivery(block, texts);
    };
    new MutationObserver(run).observe(root, {
      subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-checked'],
    });
    run();
  }

  const start = () => {
    if (window.Shopify?.designMode) return;
    document.querySelectorAll('[data-clp-product-main][data-clp-kaching]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
